import React from 'react'
import Helmet from 'react-helmet'
import { Link, graphql, StaticQuery } from "gatsby"
import {capitalize} from 'lodash';
import styled from 'styled-components'

import TemplateWrapper from '../components/layout';
import CategoryIndexStyle from './categoryIndexStyle';
import PaginationLinks from '../components/categoryIndex/PaginationLinks'
import googleTagManagerHead from '../shared/googleTagManagerHead'

const ImageStyle = styled.div`
{
  background-image: url(${props =>
    `${props.imageUrl}?nf_resize=fit&h=260`
  });
  background-size: cover;
  background-repeat: none;
  position: relative;
  // width: 335px;
  height: 221px;
  // border-radius: 4px;



  @media (min-width: 455px) {
    width: auto;
    height: auto;
  }
}`

class CategoryIndex extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      firstPageInRange: 1,
      lastPageInRange: props.pageContext.numberOfPages < 5 ? props.pageContext.numberOfPages : 5,
      lastMultOf5: 5
    }
  }

  determinePageRanges(props){
    const pageBefore = props.pageContext.humanPageNumber - 1

    if( pageBefore % 5 === 0 ){
      this.setState({lastMultOf5: pageBefore},
        () => this.recomputeProps()
      )
    }


    if (!CategoryIndex.isCurrentPageNumberInRange(props.pageContext.humanPageNumber, this.state.firstPageInRange, this.state.lastPageInRange)){
      this.setState({
        firstPageInRange: this.state.firstPageInRange + 5,
        lastPageInRange: this.state.lastPageInRange + 5
      }, () => this.recomputeProps())
    }
  }

  static isCurrentPageNumberInRange(currentPageNum, startNum, endNum){
    return currentPageNum >= startNum && currentPageNum <= endNum
  }

  componentDidMount(){
    this.determinePageRanges(this.props)
  }

  recomputeProps(){
    return {
      firstPageInRange: this.state.firstPageInRange,
      lastPageInRange: this.state.lastPageInRange,
      lastMultOf5: this.state.lastMultOf5
    }
  }


  render() {
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark
    const { category } = this.props.pageContext

    return (
      <TemplateWrapper>
        <CategoryIndexStyle>
            <Helmet>
              <title> {capitalize(category)}</title>
              {googleTagManagerHead({id: null})}
            </Helmet>
            <h1 className="header">{category}</h1>
              <div className="articlesContainer">
                {posts.map(({ node: post })=>{
                  return (
                          <Link
                            className="individualArticle"
                            to={post.fields.slug}
                            key={post.id}>
                              <ImageStyle imageUrl={post.frontmatter.image}>
                                <div className="imageContainer" />
                              </ImageStyle>
                              <div className="text">
                                <p className="title">{post.frontmatter.title}</p>
                                <div className="description">{post.frontmatter.description}</div>
                                <div className="dateAndAuthor">
                                  {post.frontmatter.date} | {post.frontmatter.author}
                                </div>
                              </div>
                          </Link>
                      )
                    })}
                <div className="nextAndBackContainer">
                  <PaginationLinks
                    {...this.recomputeProps()}
                    {...this.props.pageContext}
                    />
                </div>
              </div>
        </CategoryIndexStyle>
      </TemplateWrapper>
    )
  }
}

export default CategoryIndex

export const pageQuery = graphql`
query indexPages($category: String!, $skip: Int!, $limit: Int!){
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] },
      filter: { frontmatter: { postType: { eq: $category } }}
      skip: $skip,
      limit: $limit
  ){
    edges {
      node {
        excerpt(pruneLength: 400)
        id
        fields {
          slug
        }
        frontmatter {
          title
          templateKey
          postType
          articleTag
          image
          description
          date(formatString: "MMM D, YYYY")
          tags
          author
        }
      }
    }
  }
}
`
